/**
 * Ввод чисел в формах риск-балла (CPAYMENT-1749).
 *
 * `type='number'` здесь не используем: он пропускает минус и `e` в поле срока, показывает
 * стрелки-спиннеры и молча отдаёт пустую строку при частично введённом значении. Принятый в
 * проекте способ — `type='text'` + `inputMode='numeric'` + regex-гейт в `onChange`, который
 * НЕ ВПУСКАЕТ недопустимый символ (а не вычищает его после ввода): так каретка не прыгает.
 */

/** Корректировка балла: целое со знаком. Одинокий «-» допустим как промежуточный ввод. */
export const SIGNED_INT_INPUT_RE = /^-?\d*$/

/** Срок: только цифры, знака у него быть не может. */
export const UNSIGNED_INT_INPUT_RE = /^\d*$/

export const MIN_DURATION_MINUTES = 1
/** 30 суток — зеркалит SetTemporaryRiskChangeRequest::MAX_DURATION_MINUTES на бэке. */
export const MAX_DURATION_MINUTES = 43200

export type DurationUnit = 'minutes' | 'hours'

export const DURATION_UNIT_LABELS: Record<DurationUnit, string> = {
  minutes: 'минут',
  hours: 'часов',
}

/** `null` — в поле не целое число (пусто или одинокий «-»). */
export const parseIntegerInput = (raw: string): number | null => {
  const trimmed = raw.trim()
  if (trimmed === '' || trimmed === '-') {
    return null
  }

  const parsed = Number(trimmed)

  return Number.isInteger(parsed) ? parsed : null
}

export const toMinutes = (value: number, unit: DurationUnit): number =>
  unit === 'hours' ? value * 60 : value

/**
 * Остаток срока для предзаполнения формы: сохранение перезапускает таймер, поэтому показываем
 * то, что оператор видит в карточке, — сколько корректировке осталось жить.
 */
export const remainingDuration = (expiresAt: string): { value: number; unit: DurationUnit } => {
  const remainingMs = new Date(expiresAt).getTime() - Date.now()
  const minutes = Math.min(
    MAX_DURATION_MINUTES,
    Math.max(MIN_DURATION_MINUTES, Math.round(remainingMs / 60000)),
  )

  return minutes % 60 === 0
    ? { value: minutes / 60, unit: 'hours' }
    : { value: minutes, unit: 'minutes' }
}
